import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { selectBotFilters, updateBotFilters } from "../../store/store";
import { useAction } from "../../libraries/use-action";
import { useAppApiClient } from "../../hooks/useAppApiClient";

export const BotFiltersProvider = () => {
  const api = useAppApiClient();
  const getBotFilters = useAction(api.getBotFilters);
  const botFilters = useAppSelector(selectBotFilters);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (botFilters.length === 0) {
      getBotFilters.run();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (getBotFilters.result && getBotFilters.result.length > 0) {
      dispatch(updateBotFilters(getBotFilters.result));
    }
    // eslint-disable-next-line
  }, [getBotFilters.result]);
  return null;
};
